import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { EmptyState } from '@/lib';
import { useCapability } from '@/app/CapabilitiesProvider';
import { getStoredOrgSlug } from '@/app/auth';

export const Route = createFileRoute('/radiant')({
  component: RadiantLayout,
});

function RadiantLayout() {
  const canManage = useCapability('radiant.manage_tenants');
  const navigate = useNavigate();
  if (!canManage) {
    // The capability is granted only to radiant_superadmin tokens
    // whose tenant is in the PDM_AUTH_RADIANT_TENANT_IDS allowlist
    // (see PR #349). The most useful framing for the landed user
    // is the operational truth — this area is reserved for the
    // Radiance platform team — rather than the capability string.
    const slug = getStoredOrgSlug();
    return (
      <EmptyState
        variant="permission"
        title="Radiance platform operators only"
        body="This section is reserved for the Radiance platform team. If you reached this page by accident, head back to your dashboard."
        cta={{
          label: 'Back to dashboard',
          onClick: () => navigate({ to: slug ? `/${slug}` : '/' }),
        }}
      />
    );
  }
  return <Outlet />;
}
